import { render } from "./treeMenu2.vue?vue&type=template&id=53ab9557&scoped=true"
import script from "./treeMenu2.vue?vue&type=script&lang=js"
export * from "./treeMenu2.vue?vue&type=script&lang=js"

import "./treeMenu2.vue?vue&type=style&index=0&id=53ab9557&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ab9557"]])

export default __exports__